import lang from '@/lang/middleware/pages/terms';

export default ({ store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('description');
  const subtitle = store.$i18n.t('jumbotron.subtitle');
  const title = store.$i18n.t('title');
  store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'generic' });
  store.commit('pageContent/setHead', { description, title });
};
